import React from "react";
import { cn } from "src/lib/utils";

const InfoRow = ({ title, children, className, containerClassName }) => {
	return (
		<div className={cn("tw-flex tw-justify-between tw-items-center tw-gap-10", containerClassName)}>
			<p className="tw-text-gray tw-font-normal tw-text-[15px]">{title}</p>
			{typeof children === "string" || typeof children === "number" ? (
				<p className={cn("tw-text-gray tw-text-[15px] tw-font-semibold", className)}>{children}</p>
			) : (
				children
			)}
		</div>
	);
};

export default InfoRow;
